module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ebc2fa4e1e71773cc92275b58f140c39.png";